/* global $ */

require('./lib/extend')
require('./credentials/extend')

$(() => {
    // Typekit events
    require('./lib/typekit')

    // Header bar
    // require('./lib/header')

    // Loading creds etc
    require('./credentials/bugsnag')

    // Loading creds etc
    require('./credentials/creds')

    // Responsive items
    require('./credentials/responsive')

    // Slider
    require('./lib/slider')

    // Intercom triggers
    require('./lib/intercom')
})



/** WEBPACK FOOTER **
 ** ./js/creds.js
 **/